module.exports = __webpack_public_path__ + "static/media/tolerance.d0a944ad.svg";